<ng-container *ngIf="shouldRender">
  <div
    #backdrop
    class="bottom-sheet-backdrop"
    [class.visible]="isVisible"
    (click)="onBackdropClick()"
  ></div>
  <section
    #sheet
    class="bottom-sheet"
    [class.bottom-sheet--edge-to-edge]="edgeToEdge"
    [class.bottom-sheet--auto]="isAutoHeight"
    [class.bottom-sheet--dragging]="isDragging"
    [class.bottom-sheet-open]="isVisible"
    [class.dark]="dark"
    [attr.aria-label]="ariaLabel"
    role="dialog"
    aria-modal="true"
    [ngStyle]="darkTheme"
    [style.height]="isAutoHeight ? null : height"
    (pointerdown)="onPointerDown($event)"
  >
    <div class="bottom-sheet-handle" aria-hidden="true"></div>
    <ng-content select="[sheetHeader]"></ng-content>
    <div #sheetBody class="bottom-sheet-body">
      <ng-content select="[sheetBody]"></ng-content>
    </div>
    <div class="bottom-sheet-footer">
      <ng-content select="[sheetFooter]"></ng-content>
    </div>
  </section>
</ng-container>
